import {
  Button,
  CircularProgress,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { httpService, loggedInUser } from "../httpService";
import { RefreshContext, OfficialsContext } from "../contexts/AlertContext";
import { exportToExcel, JsonToExcel } from "react-json-to-excel";

import logo from "../pages/logo.png";
import { formatter } from "../routes/formatter";
import { institutionsCount } from "./institutions";
export default function OfficialsWidgets() {
  const [results, setResults] = useState([]);
  const [incomplete, setIncomplete] = useState([]);

  const getData = async () => {
    const { data } = await httpService.get("institutions");
    if (data) {
      setResults(data.detailedWork);
    }
  };

  const getIncomplete = async () => {
    const { data } = await httpService.get("incompleteregistrations");
    if (data) {
      setIncomplete(data);
    }
  };

  useEffect(() => {
    getData();
    getIncomplete();

    const timer = setInterval(() => {
      getData();
      getIncomplete();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  return (
    <div className="dashboardBanner ">
      <div className="container pt-5 pb-5">
        <div className="text-center mb-1">
          <img src={logo} width={110} height={90} alt="Jamb logo" />
        </div>
        <Typography
          textAlign={"center"}
          variant="h6"
          gutterBottom
          textTransform={"uppercase"}
          color={"white"}
        >
          {new Date().getFullYear()} policy meeting monitoring dashboard
        </Typography>
        <div className="">
          <div className="d-flex flex-wrap justify-content-center">
            <ViceChancelors />
            <Rectors />
            <Provosts />

            <Registrars />
            <AdmissionOfficers />
            <Ict />
            <ChairmanCommitte />
            <Institutions />
            <LoadingComponent />
          </div>
        </div>
        {loggedInUser && loggedInUser.role === "admin" && (
          <div className="d-flex justify-content-center">
            <Stack spacing={1} direction={"row"}>
              <div className="">
                <JsonToExcel
                  title="Institutions File"
                  data={results}
                  fileName="INSTITUTIONS"
                />
              </div>
              <div className="">
                <JsonToExcel
                  title="Incomplete Registrations"
                  data={incomplete}
                  fileName="Incomplete Registrations"
                />
              </div>
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
}

function LoadingComponent() {
  const [total, setTotal] = useState("0");

  const getData = async () => {
    const { data } = await httpService.get("totalregistered");
    if (data) setTotal(data);
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  const { loading } = useContext(RefreshContext);
  return (
    <>
      {loading ? (
        <div className="col-lg-3 mb-1 me-1 p-3 timerComponent d-flex align-items-center justify-content-center">
          <CircularProgress sx={{ color: "white" }} />
        </div>
      ) : (
        <div className="col-lg-3 mb-1 me-1 p-3 timerComponent color d-flex align-items-center text-white justify-content-between">
          <Typography variant="caption">Participants</Typography>

          <Typography variant="h4">{total}</Typography>
        </div>
      )}
    </>
  );
}

function ViceChancelors() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get(
      "viewofficials?role=Vice Chancellor"
    );
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);

  const showData = () => {
    setShow({
      display: true,
      data: { title: "Vice Chancellors list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Vice Chancellors</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}

function Rectors() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get("viewofficials?role=Rector");
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  const showData = () => {
    setShow({
      display: true,
      data: { title: "Rectors list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Rectors</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}

function Provosts() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get("viewofficials?role=Provost");
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);

  const showData = () => {
    setShow({
      display: true,
      data: { title: "Provosts list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Provosts</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}

function Registrars() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get("viewofficials?role=Registrar");
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  const showData = () => {
    setShow({
      display: true,
      data: { title: "Registrars list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Registrars</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}

function AdmissionOfficers() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get(
      "viewofficials?role=Admissions Officer"
    );
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  const showData = () => {
    setShow({
      display: true,
      data: { title: "Admissions Officers list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Admissions Officers</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}

function Ict() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get("viewofficials?role=Head of ICT");
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);

  const showData = () => {
    setShow({
      display: true,
      data: { title: "Heads of ICT list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Heads of ICT</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}

function ChairmanCommitte() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get(
      "viewofficials?role=Chairman, Admissions Committee"
    );
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);

  const showData = () => {
    setShow({
      display: true,
      data: {
        title: "Chairman Committee on Admissions list",
        list: formatter(results),
      },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">
        Chairman Committee on Admissions
      </Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}
function Institutions() {
  const [results, setResults] = useState(0);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get("institutions");
    if (data) {
      setResults(data.institutions);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  return (
    <div className="col-lg-3 mb-1 me-1 p-3 institution d-flex justify-content-between align-items-center">
      <Typography variant="caption">Institutions</Typography>

      <Typography variant="h4">{results}</Typography>
    </div>
  );
}

function JambStaff() {
  const [results, setResults] = useState([]);
  const { setShow } = useContext(OfficialsContext);
  const getData = async () => {
    const { data } = await httpService.get("viewofficials?role=Registrar");
    if (data) {
      setResults(data);
    }
  };

  useEffect(() => {
    getData();

    const timer = setInterval(() => {
      getData();
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);
  const showData = () => {
    setShow({
      display: true,
      data: { title: "Registrars list", list: formatter(results) },
    });
  };
  return (
    <div
      onClick={showData}
      className="col-lg-3 mb-1 me-1 p-3 viceChancelors d-flex justify-content-between align-items-center"
    >
      <Typography variant="caption">Jamb Staff</Typography>

      <Typography variant="h4">{results.length}</Typography>
    </div>
  );
}
